import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD7Bhw1jr5O-hIdcE-RVXu5I9Gd9z9iNNI",
  authDomain: "fantapp-e658c.firebaseapp.com",
  projectId: "fantapp-e658c",
  storageBucket: "fantapp-e658c.firebasestorage.app",
  messagingSenderId: "711797562085",
  appId: "1:711797562085:web:80040a6a6cf9fb3aa1d20c"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();